export default __webpack_public_path__ + "static/media/marketplace2.81a6100d.jpg";